import { cn } from "@/lib/utils"

interface ScrollWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  ref?: React.Ref<HTMLDivElement>
  testId?: string
  containerClassName?: string
}

export const ScrollWrapper = ({ className, containerClassName, ref, children, testId }: ScrollWrapperProps) => {
  return (
    <div className={cn("group/scrollbar flex flex-1 flex-col overflow-hidden", containerClassName)}>
      <div
        ref={ref}
        data-testid={testId}
        className={cn(
          "scrollbar scrollbar-thumb-rounded-full scrollbar-w-1.5 group-hover/scrollbar:scrollbar-thumb-surface-hovered hover:scrollbar-thumb-surface-pressed grid scrollbar-thumb-transparent overflow-x-hidden overflow-y-auto",
          className,
        )}>
        <div className="flex flex-col">{children}</div>
      </div>
    </div>
  )
}
